import { render, staticRenderFns } from "./FulfillmentCollectionView.vue?vue&type=template&id=555aadeb&"
import script from "./FulfillmentCollectionView.vue?vue&type=script&lang=ts&"
export * from "./FulfillmentCollectionView.vue?vue&type=script&lang=ts&"
import style0 from "./FulfillmentCollectionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VSlideYTransition})
